import React from 'react';
import { Tooltip } from '../Tooltip';

import './styles.css';

export const TextInfo = ({ text, info, tooltip }) => {
  return (
    <div className="text-info__container">
      <span className="text-info__text">{text}: </span>
      <span className="text-info__info">{info}</span>
      {tooltip && <Tooltip title={tooltip}>?</Tooltip>}
    </div>
  );
};
